export enum FontSize {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xl2 = '2xl',
}

const fontSizes = {
  [FontSize.xs]: '12px',
  [FontSize.sm]: '14px',
  [FontSize.md]: '16px',
  [FontSize.lg]: '20px',
  [FontSize.xl]: '22px',
  [FontSize.xl2]: '34px',
};

export default fontSizes;
